(function (){
    'use strict';

    var bgCanvas = {
        template: '<div class="bg-canvas-wrapper">' +
                        '<canvas id="canvas"></canvas>' +
                    '</div>',
        controller: bgCanvasController
    };

    angular
        .module('jotApp')
        .component ('bgCanvas', bgCanvas);

    function bgCanvasController() {
        // RequestAnimFrame: a browser API for getting smooth animations
        window.requestAnimFrame = (function () {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
        })();

        // Initializing the canvas
        // I am using native JS here, but you can use jQuery,
        // Mootools or anything you want
        var canvas = document.getElementById("canvas");

        // Initialize the context of the canvas
        var ctx = canvas.getContext("2d");

        // Set the canvas width and height to occupy full window
        var W = window.innerWidth, H = window.innerHeight;
        canvas.width = W;
        canvas.height = H;

        //manage window resize
        $(window).on('resize', function () {
            W = window.innerWidth;
            H = window.innerHeight;
            canvas.width = W;
            canvas.height = H;
        });

        // Some variables for later use
        var particleCount = 10 + Math.ceil(24 * (W * H) / (1920 * 1080));
        var twinParticleCount = 4;
        var particles = [];
        var minDist = 72;
        const attractiveness = 1 / 2000;
        const velocity = 1.07;      // 0.2+1.07^5=1.6
        const minVelocity = 0.2;    // initial velocity: [0.2, 1.6]
        const maxVelocity = 1.5;
        const autoVeloxDeceleration = 0.99996;

        // Function to paint the canvas black
        function paintCanvas() {
            // Set the fill color to black
            ctx.fillStyle = "rgba(0,0,0,1)";

            // This will create a rectangle of white color from the
            // top left (0,0) to the bottom right corner (W,H)
            ctx.fillRect(0, 0, W, H);
        }

        // Now the idea is to create some particles that will attract
        // each other when they come close. We will set a minimum
        // distance for it and also draw a line when they come
        // close to each other.

        // The attraction can be done by increasing their velocity as
        // they reach closer to each other

        // Let's make a function that will act as a class for
        // our particles.

        function Particle() {
            // Position them randomly on the canvas
            // Math.random() generates a random value between 0
            // and 1 so we will need to multiply that with the
            // canvas width and height.
            this.x = Math.random() * W;
            this.y = Math.random() * H;


            // We would also need some velocity for the particles
            // so that they can move freely across the space
            this.vx = (Math.random() - 0.5) * 2 * velocity;
            this.vy = (Math.random() - 0.5) * 2 * velocity;
            this.vx = Math.pow(this.vx, 5) + (Math.sign(this.vx) * minVelocity);
            this.vy = Math.pow(this.vy, 5) + (Math.sign(this.vy) * minVelocity);
            // = Math.sign(this.vx) * (Math.pow(this.vx, 4) + minVelocity)
            // = Math.sign(this.vy) * (Math.pow(this.vy, 4) + minVelocity)

            // Now the radius of the particles. I want all of
            // them to be equal in size so no Math.random() here..
            this.radius = 4;


            // This is the method that will draw the Particle on the
            // canvas. It is using the basic fillStyle, then we start
            // the path and after we use the `arc` function to
            // draw our circle. The `arc` function accepts four
            // parameters in which first two depicts the position
            // of the center point of our arc as x and y coordinates.
            // The third value is for radius, then start angle,
            // end angle and finally a boolean value which decides
            // whether the arc is to be drawn in counter clockwise or
            // in a clockwise direction. False for clockwise.
            this.draw = function () {
                ctx.fillStyle = 'rgb(246 246 246 / 50%)';
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);

                // Fill the color to the arc that we just created
                ctx.fill();
            }
        }

        // Time to push the particles into an array
        for (var i = 0; i < particleCount - twinParticleCount; i++) {
            particles.push(new Particle());
        }
        for (var i = 0; i < twinParticleCount; i++) {
            var twinParticle = new Particle();
            twinParticle.x = particles[i].x + around(minDist/3, minDist * 0.886);
            twinParticle.y = particles[i].y + around(minDist/3, minDist * 0.886);
            particles.push(twinParticle);
        }

        function around(min, max) {
            var a = Math.pow((Math.random() - 0.5) * 2, 2);
            return a * (max - min) + Math.sign(a) * min;
        }

        // Function to draw everything on the canvas that we'll use when
        // animating the whole scene.
        function draw() {

            // Call the paintCanvas function here so that our canvas
            // will get re-painted in each next frame
            paintCanvas();

            // Call the function that will draw the balls using a loop
            // particles.forEach(p => p.draw());
            particles.forEach(
                function (p){
                    p.draw();
                }
            );

            //Finally call the update function
            update();
        }

        // Give every particle some life
        function update() {

            // In this function, we are first going to update every
            // particle's position according to their velocities
            for (var i = 0; i < particles.length; i++) {
                var p = particles[i];

                p.interaction = 0;

                // Change the velocities
                p.x += p.vx;
                p.y += p.vy

                // We don't want to make the particles leave the
                // area, so just change their position when they
                // touch the walls of the window
                if (p.x + p.radius > W)
                    p.x = p.radius;

                else if (p.x - p.radius < 0) {
                    p.x = W - p.radius;
                }

                if (p.y + p.radius > H)
                    p.y = p.radius;

                else if (p.y - p.radius < 0) {
                    p.y = H - p.radius;
                }

                // Now we need to make them attract each other
                // so first, we'll check the distance between
                // them and compare it to the minDist we have
                // already set

                // We will need another loop so that each
                // particle can be compared to every other particle
                // except itself
                for (var j = i + 1; j < particles.length; j++) {
                    var p2 = particles[j];
                    distanceCalculator(p, p2);
                }

            }
            /*particles.forEach(p => {
                if (p.interaction < 4) {
                    p.vx = autoVelox(p.vx);
                    p.vy = autoVelox(p.vy);
                } else if(p.interaction > 8){
                    p.vx = autoDemolish(p.vx, p.interaction);
                    p.vy = autoDemolish(p.vy, p.interaction);
                }
            })*/
            particles.forEach(
                function (p){
                    if (p.interaction < 4) {
                        p.vx = autoVelox(p.vx);
                        p.vy = autoVelox(p.vy);
                    } else if(p.interaction > 8){
                        p.vx = autoDemolish(p.vx, p.interaction);
                        p.vy = autoDemolish(p.vy, p.interaction);
                    }
                }
            )
        }

        function autoDemolish(v, i) {
            return v * (1 + (0.0000001 * i));
        }

        function autoVelox(v) {
            if(Math.abs(v) > maxVelocity) {
                return v * autoVeloxDeceleration;
            }
            return v;
        }

        // Distance calculator between two particles
        function distanceCalculator(p1, p2) {
            var distance;
            var dx = p1.x - p2.x;
            var dy = p1.y - p2.y;

            distance = Math.sqrt(dx * dx + dy * dy);

            // Draw the line when distance is smaller
            // then the minimum distance
            if (distance <= minDist) {

                // Draw the line
                ctx.beginPath();
                ctx.strokeStyle = "rgba(255,255,255," + (1.2 - distance / minDist) + ")";
                ctx.moveTo(p1.x, p1.y);
                ctx.lineTo(p2.x, p2.y);
                ctx.stroke();
                ctx.closePath();

                // Some acceleration for the partcles
                // depending upon their distance
                var ax = dx * attractiveness,
                    ay = dy * attractiveness;

                p1.interaction++;
                // Apply the acceleration on the particles
                p1.vx -= ax;
                p1.vy -= ay;

                p2.vx += ax;
                p2.vy += ay;
            }
        }

        // Start the main animation loop using requestAnimFrame
        function animloop() {
            draw();
            requestAnimFrame(animloop);
        }

        animloop();
    }
})();
